// extracted by mini-css-extract-plugin
export default {"topBar":"styles_topBar__pkSvj","logo":"styles_logo__UL2Fd","backBtn":"styles_backBtn__+wXNd","title":"styles_title__xLkz2"};